module.exports = __webpack_public_path__ + "static/media/methodology_image.63af4efe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/services/methodology_image.png
// module id = 318
// module chunks = 0